/* eslint-disable no-underscore-dangle */
import { Component, Input, ViewChildren, SimpleChanges, OnChanges, ViewContainerRef, QueryList } from '@angular/core';

import { DynamicContent, GUIComponent } from 'hisng';

import { DYNAMIC_FIELDSET_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

@Component({
    selector: 'res-dynamic-tab-container',
    templateUrl: './dynamic-tab-container.component.html',
    providers: [ProviderManager.getComponentProvider(DynamicTabContainerComponent)],
})
export class DynamicTabContainerComponent implements OnChanges {
    @Input() objectDynamicContent: DynamicContent;
    @Input() hisDynamicContent: string;
    @Input() reloadTrigger: boolean;
    @Input() target: string;
    @Input() fullWidth = false;
    
    //Infopanel not shown if component is used as nested panel
    @Input() showOwnInfoPanel= true;
    @ViewChildren(DYNAMIC_FIELDSET_ANCHOR, { read: ViewContainerRef }) fieldsetViewContainerList: QueryList<ViewContainerRef>;

    public dynamicTabChildCount: GUIComponent[] = [];

    ngOnChanges(changes: SimpleChanges) {
        if (changes.objectDynamicContent || changes.reloadTrigger) {
            // trigger re-render
            if (this.objectDynamicContent._dynamicComponent) {
                this.objectDynamicContent._dynamicComponent = { ...this.objectDynamicContent._dynamicComponent };
                this.objectDynamicContent._dynamicComponent.guiComponent.children.forEach((dynamicTabContainer: GUIComponent) => {
                    if (dynamicTabContainer.name === this.hisDynamicContent) {
                        // set position
                        this.setTemporaryPositionForChildren(dynamicTabContainer);
                        // set dynamic tab children for #dynamicFieldSetContainer iterator
                        this.dynamicTabChildCount = dynamicTabContainer.children;
                    }
                });
            }
        }
    }

    // set temporary position
    private setTemporaryPositionForChildren(dynamicTabContainer: GUIComponent): void {
        dynamicTabContainer.children.forEach( ( ccc: GUIComponent ) => ccc.position = 0 );
    }
}
